import { ObjectBuilder, Image3D, ImgButton, LayoutUtils } from "@dreamcam/babylon-tools";
import { Container } from "@babylonjs/gui/2D/controls/container.js";
import { Env } from "../../../settings/Env";
import { Control } from "@babylonjs/gui/2D/controls/control.js";
import { text } from "../../../TextResources";
export class GuestPanel {
    constructor(mesh2d, positionInPixels, sizeInPixels, createSignUpButton) {
        const gue = Env.common.profileButton.guest;
        this.rootContainer = new Container("clientContainer");
        this.rootContainer.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
        this.rootContainer.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        this.rootContainer.widthInPixels = sizeInPixels.width;
        this.rootContainer.heightInPixels = sizeInPixels.height;
        this.rootContainer.leftInPixels = positionInPixels.left;
        this.rootContainer.topInPixels = positionInPixels.top;
        this.guestButton = new ImgButton("guestButton", LayoutUtils.GetButtonLayout(gue.signInButton.colorLayout, mesh2d));
        this.guestButton.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
        this.guestButton.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        this.guestButton.leftInPixels = mesh2d.m2px(gue.signInButton.left);
        this.guestButton.topInPixels = mesh2d.m2px(gue.signInButton.top);
        this.guestButton.widthInPixels = mesh2d.m2px(gue.signInButton.width);
        this.guestButton.heightInPixels = mesh2d.m2px(gue.signInButton.height);
        this.rootContainer.addControl(this.guestButton);
        const image = new Image3D("signInImage", gue.signInButton.children.image.src);
        image.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
        image.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        image.widthInPixels = mesh2d.m2px(gue.signInButton.children.image.width);
        image.heightInPixels = mesh2d.m2px(gue.signInButton.children.image.height);
        image.leftInPixels = mesh2d.m2px(gue.signInButton.children.image.left);
        image.topInPixels = mesh2d.m2px(gue.signInButton.children.image.top);
        this.guestButton.addControl(image);
        const signInLabel = ObjectBuilder.createTextBlock3D(mesh2d, "signInLabel", text.lobby_userPanel_signin, gue.signInButton.children.label);
        this.guestButton.addControl(signInLabel);
        if (createSignUpButton) {
            this.signUpButton = new ImgButton("signUpButton", LayoutUtils.GetButtonLayout(gue.signUpButton.colorLayout, mesh2d));
            this.signUpButton.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
            this.signUpButton.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
            this.signUpButton.leftInPixels = mesh2d.m2px(gue.signUpButton.left);
            this.signUpButton.topInPixels = mesh2d.m2px(gue.signUpButton.top);
            this.signUpButton.widthInPixels = mesh2d.m2px(gue.signUpButton.width) - 2;
            this.signUpButton.heightInPixels = mesh2d.m2px(gue.signUpButton.height);
            this.rootContainer.addControl(this.signUpButton);
            const signUpLabel = ObjectBuilder.createTextBlock3D(mesh2d, "signUpLabel", text.lobby_userPanel_signup, gue.signUpButton.children.label);
            this.signUpButton.addControl(signUpLabel);
        }
        else {
            this.signUpButton = null;
        }
    }
}
